import { eventsApi } from '@/features/events/api';
import type { XkEventGroup } from '@/lib/api/types';

/**
 * The project an event belongs to, creating one if the brand has none.
 *
 * Events live inside projects, which is a sound model — a project is the
 * campaign an activation belongs to — but it is not a fact a new customer
 * knows. Pressing "create an event" on their first day used to open a panel
 * that said "create a project first" and offered nothing but Cancel: a dead
 * end two steps into the three-step path, with the vocabulary lesson standing
 * in for the feature.
 *
 * So the first event quietly gets a project named after the brand. Managers who
 * think in campaigns can rename it or make more; managers who never think about
 * projects at all never have to.
 */
export async function ensureProject(
  brandId: number,
  brandName: string | null | undefined,
): Promise<XkEventGroup> {
  const existing = await eventsApi.listGroups({ companyId: brandId });
  const first = existing.items[0];
  if (first) return first;

  return eventsApi.createGroup({
    name: brandName?.trim() || 'My first project',
    companyId: brandId,
  });
}
